
import { trackEvent } from './index';

// Job-specific tracking events
export const jobTracking = {
  // Job creation and management
  trackJobCreated: (jobData: { job_id: string; title: string; company?: string; location?: string; type?: string; salary_range?: string; source?: string }) => {
    trackEvent('job_created', {
      job_id: jobData.job_id,
      job_title: jobData.title,
      company: jobData.company,
      location: jobData.location,
      employment_type: jobData.type,
      salary_range: jobData.salary_range,
      source: jobData.source || 'manual',
      engagement_time_msec: '1',
    });
  },

  trackJobUpdated: (jobData: { job_id: string; title: string; updated_fields: string[]; company?: string }) => {
    trackEvent('job_updated', {
      job_id: jobData.job_id,
      job_title: jobData.title,
      company: jobData.company,
      updated_fields: jobData.updated_fields.join(','),
    });
  },

  trackJobStatusChanged: (jobData: { job_id: string; title: string; from_status?: string; to_status: string; company?: string }) => {
    trackEvent('job_status_change', {
      job_id: jobData.job_id,
      job_title: jobData.title,
      company: jobData.company,
      from_status: jobData.from_status,
      to_status: jobData.to_status,
    });
  },

  trackJobDuplicated: (jobData: { original_job_id: string; new_job_id: string; title: string; company?: string }) => {
    trackEvent('job_duplicated', {
      original_job_id: jobData.original_job_id,
      new_job_id: jobData.new_job_id,
      job_title: jobData.title,
      company: jobData.company,
    });
  },

  trackJobViewed: (jobData: { job_id: string; title: string; company?: string; view_context?: string }) => {
    trackEvent('job_view', {
      job_id: jobData.job_id,
      job_title: jobData.title,
      company: jobData.company,
      view_context: jobData.view_context || 'detail_page',
    });
  },

  // Application tracking
  trackApplicationReceived: (applicationData: { job_id: string; candidate_id: string; job_title: string; candidate_name?: string; source?: string }) => {
    trackEvent('application_received', {
      job_id: applicationData.job_id,
      candidate_id: applicationData.candidate_id,
      job_title: applicationData.job_title,
      candidate_name: applicationData.candidate_name,
      application_source: applicationData.source || 'manual',
    });
  },

  trackApplicationStatusChanged: (applicationData: { job_id: string; candidate_id: string; job_title: string; from_status?: string; to_status: string }) => {
    trackEvent('application_status_change', {
      job_id: applicationData.job_id,
      candidate_id: applicationData.candidate_id,
      job_title: applicationData.job_title,
      from_status: applicationData.from_status,
      to_status: applicationData.to_status,
    });
  },

  // Job performance metrics
  trackJobPlacement: (placementData: { job_id: string; candidate_id: string; job_title: string; candidate_name?: string; placement_fee?: number }) => {
    trackEvent('job_placement', {
      job_id: placementData.job_id,
      candidate_id: placementData.candidate_id,
      job_title: placementData.job_title,
      candidate_name: placementData.candidate_name,
      placement_fee: placementData.placement_fee,
      value: placementData.placement_fee || 1,
    });
  },

  trackJobClosed: (jobData: { job_id: string; title: string; reason: string; total_applications?: number; time_to_fill?: number }) => {
    trackEvent('job_closed', {
      job_id: jobData.job_id,
      job_title: jobData.title,
      closure_reason: jobData.reason,
      total_applications: jobData.total_applications,
      time_to_fill_days: jobData.time_to_fill,
    });
  },
};

// Individual function exports for direct import
export const trackJobCreated = jobTracking.trackJobCreated;
export const trackJobUpdated = jobTracking.trackJobUpdated;
export const trackJobStatusChanged = jobTracking.trackJobStatusChanged;
export const trackJobDuplicated = jobTracking.trackJobDuplicated;
export const trackJobViewed = jobTracking.trackJobViewed;
export const trackApplicationReceived = jobTracking.trackApplicationReceived;
export const trackApplicationStatusChanged = jobTracking.trackApplicationStatusChanged;
export const trackJobPlacement = jobTracking.trackJobPlacement;
export const trackJobClosed = jobTracking.trackJobClosed;
